import { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { Button, Input, Spin } from "antd";
import VerAnexos from "../VerAnexos";
import GestionesJuridica from "../ConsultaGestiones";

const API_URLS = [
  "https://contratosback.azurewebsites.net/api/v1/ObtenerJuridicoAsignadas/0/1",
  "https://contratosback.azurewebsites.net/api/v1/ObtenerJuridicoAsignadas/0/2",
  "https://contratosback.azurewebsites.net/api/v1/ObtenerJuridicoAsignadas/0/3",
];

function HistorialCaso() {
  const [rows, setRows] = useState([]);
  const [pagina, setPagina] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const registrosPorPagina = 10;

  const fetchData = useCallback(async () => {
    setLoading(true); // Inicia el loader
    try {
      const responses = await Promise.all(API_URLS.map((url) => axios.get(url)));

      const combinedData = responses.flatMap((res) =>
        res.data.map((item) => ({
          id: `${item.id}`,
          nombreTema: item.nombreTema,
          titulo: item.titulo,
          fechaCreacion: new Date(item.fechaCreacion).toLocaleDateString(),
          nombreAsignacion: item.nombreAsignacion,
          nombreCreacion: item.nombreCreacion,
          estado: item.name,
          nit: item.nit,
        }))
      );

      setRows(combinedData);
      setPagina(1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Finaliza el loader
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const filteredRows = useMemo(() => {
    return rows.filter((row) =>
      Object.values(row).some((value) => value?.toString().toLowerCase().includes(searchTerm))
    );
  }, [rows, searchTerm]);

  const totalPaginas = Math.ceil(filteredRows.length / registrosPorPagina);
  const rowsPaginados = useMemo(() => {
    const startIndex = (pagina - 1) * registrosPorPagina;
    return filteredRows.slice(startIndex, startIndex + registrosPorPagina);
  }, [filteredRows, pagina, registrosPorPagina]);

  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Tema", accessor: "nombreTema" },
    { Header: "Titulo", accessor: "titulo" },
    { Header: "Fecha Creación", accessor: "fechaCreacion" },
    { Header: "Usuario Creación", accessor: "nombreAsignacion" },
    { Header: "Usuario Asignación", accessor: "nombreCreacion" },
    { Header: "Estado", accessor: "estado" },
    { Header: "NIT", accessor: "nit" },
    {
      Header: "Ver Anexos",
      accessor: "verAnexos",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => <VerAnexos id={row.original.id} />,
    },
    {
      Header: "Gestiones ",
      accessor: "gestionesJuridicas",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        // eslint-disable-next-line react/prop-types
        <GestionesJuridica id={row.original.id} descripcion={row.original.descripcion} />
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Historial de casos
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" alignItems="center" height="300px">
                    <Spin size="large" tip="Cargando..." />
                  </MDBox>
                ) : (
                  <>
                    <Input
                      placeholder="Buscar..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                      style={{ margin: "10px 20px", width: "650px" }}
                    />
                    <DataTable
                      table={{ columns, rows: rowsPaginados }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />
                    <MDBox display="flex" justifyContent="center" alignItems="center" mt={2}>
                      <Button
                        onClick={() => setPagina((p) => Math.max(p - 1, 1))}
                        disabled={pagina === 1}
                      >
                        Anterior
                      </Button>
                      <MDTypography mx={2}>
                        {pagina} de {totalPaginas}
                      </MDTypography>
                      <Button
                        onClick={() => setPagina((p) => Math.min(p + 1, totalPaginas))}
                        disabled={pagina === totalPaginas}
                      >
                        Siguiente
                      </Button>
                    </MDBox>
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default HistorialCaso;
